// #region Dependencias
import { Form, Input, InputSelect, InputTextArea } from 'components/Library'
import { ESTADOS } from 'utils/constants'
// #endregion

/**
 * Componente que maneja la edición de productos y pagos en las landing pages.
 * @class
 * @param {Object} props - Propiedades del componente.
 * @param {Object} props.formValues - Objeto con los valores de los campos del formulario de la página.
 * @param {Function} props.handleInputChange - Callback para actualizar los valores de un elemento de la página.
 */
const MenuProducts = ({ formValues, handleInputChange }) => {
  return (
    <Form
      style={{
        padding: '1rem'
      }}
    >
      <InputSelect
        name={'opciones.seccionPagos'}
        label="Estado"
        helper="Estado de pagos"
        options={ESTADOS}
        value={formValues.opciones.seccionPagos}
        onChange={handleInputChange}
      />
      <Input
        name="productos.0.nombre"
        label="Nombre del producto"
        helper="Nombre del producto"
        placeholder="Plan guanabana"
        value={formValues.productos[0].nombre}
        onChange={handleInputChange}
      />
      <InputTextArea
        name={'productos.0.descripcion'}
        label="Descripción del producto"
        helper="Descripción del producto para facturación"
        value={formValues.productos[0].descripcion}
        onChange={handleInputChange}
      />
      <Input
        name={'productos.0.precioUnitario'}
        label="Precio de producto"
        type="number"
        helper="Precio del producto en dólares"
        placeholder="1.00"
        pattern="^\d*(\.\d{0,2})?$"
        step={0.25}
        value={parseFloat(formValues.productos[0].precioUnitario).toFixed(2)}
        onChange={handleInputChange}
      />
    </Form>
  )
}

export default MenuProducts
